import { z } from 'zod';
/**
 * Deutsche Fehlermeldungen für alle Prüfungen.
 *
 * Ohne diesen Aufruf antwortet die Prüfschicht auf Englisch — und diese Texte
 * landen nicht nur im Protokoll, sondern über die HTTP-Schnittstelle auch beim
 * Fahrer. „Too small: expected number to be >0" hilft niemandem in einem
 * fahrenden Auto.
 *
 * Muss beim Start jedes Teils einmal aufgerufen werden: Backend, Weboberfläche,
 * Simulator. Die Einstellung gilt für die gesamte Laufzeitumgebung.
 */
export function installGermanMessages() {
    z.config(z.locales.de());
}
//# sourceMappingURL=validation.js.map